import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetClientNewsletter } from '~/hooks';

type Args = {
  newsId: number;
};

/**
 * 社内報詳細ヘッダーコンポーネント専用フック
 * 社内報タイトルを取得して返す
 */
export const useInternalNewsDetailHeader = ({ newsId }: Args) => {
  const { data } = useGetClientNewsletter({
    threeLetterCode: getThreeLetterCode() || '',
    id: newsId,
  });
  return { title: data.client_newsletter.title };
};
